
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BarChart, ExternalLink, Megaphone, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import ROUTES from '@/routes-map';

interface AdPerformanceInsightsProps {
  stats: {
    activeAds: number;
    totalImpressions: number;
    ctr: number;
    leadsGenerated: number;
    changePercent?: number;
  };
}

const AdPerformanceInsights: React.FC<AdPerformanceInsightsProps> = ({ stats }) => {
  return (
    <Card className="mb-6">
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>Ad Performance</CardTitle>
          <CardDescription>Overview of your advertising performance</CardDescription>
        </div>
        <Megaphone className="h-5 w-5 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-muted/30 p-4 rounded-lg flex flex-col items-center justify-center">
            <span className="text-sm text-muted-foreground">Active Ads</span>
            <span className="text-2xl font-bold">{stats.activeAds}</span>
          </div>
          <div className="bg-muted/30 p-4 rounded-lg flex flex-col items-center justify-center">
            <span className="text-sm text-muted-foreground">Total Impressions</span>
            <span className="text-2xl font-bold">{stats.totalImpressions.toLocaleString()}</span>
          </div>
          <div className="bg-muted/30 p-4 rounded-lg flex flex-col items-center justify-center">
            <span className="text-sm text-muted-foreground">Click-Through Rate</span>
            <span className="text-2xl font-bold">{stats.ctr.toFixed(1)}%</span>
          </div>
          <div className="bg-muted/30 p-4 rounded-lg flex flex-col items-center justify-center">
            <span className="text-sm text-muted-foreground">Leads Generated</span>
            <span className="text-2xl font-bold">{stats.leadsGenerated}</span>
            {stats.changePercent && (
              <span className={`text-xs ${stats.changePercent >= 0 ? 'text-green-500' : 'text-red-500'}`}>
                {stats.changePercent > 0 ? '+' : ''}{stats.changePercent}% from last period
              </span>
            )}
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild className="flex-1">
            <Link to={ROUTES.DOCTOR.ADS}>
              <BarChart className="mr-2 h-4 w-4" />
              View Full Ad Analytics
            </Link>
          </Button>
          <Button variant="outline" asChild className="flex-1">
            <Link to={`${ROUTES.DOCTOR.ADS}?tab=purchase`}>
              <Plus className="mr-2 h-4 w-4" />
              Create New Ad
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default AdPerformanceInsights;
